import React from 'react';

const XIcon = ({ color = '#667085', width = 20, height = 21, ...rest }) => {
  return (
    <svg {...rest} height={height} width={width} fill="none" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.05469 13.4472L12.9472 7.55469" stroke={color} strokeLinecap="round" strokeWidth="1.5" />
      <path d="M7.05469 7.55469L12.9472 13.4472" stroke={color} strokeLinecap="round" strokeWidth="1.5" />
    </svg>
  );
};

export default XIcon;
